import React from 'react';

const TextDescriptionSectionMaster = ({textDescriptionSectionMaster}) => (
    <p className="text-for-blog">
        {textDescriptionSectionMaster}
    </p>
)

export default TextDescriptionSectionMaster;
